import { render } from "./HelloWorld.vue?vue&type=template&id=43b5c370&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=43b5c370&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43b5c370"

export default script